export default __webpack_public_path__ + "static/media/trickshot.f2caa312.webp";